import { useNavigate, useOutletContext} from "react-router-dom";
import { NotesList } from "../../Notes/NotesList";

export const LifeInsuranceNoteFormList = () => {
    const data = useOutletContext() as any;
    const customerId = data[0];
    const customerPolicyId = data[1];

    const navigate = useNavigate();
    const handleAddEditClick = (incrementalNumber: number | null = null) => {
        if (incrementalNumber !== null) {
            navigate(
                `/life-insurance-policy/${customerId}/notes-tab/${customerPolicyId}/note/${incrementalNumber}`
            );
        } else {
            navigate(
                `/life-insurance-policy/${customerId}/notes-tab/${customerPolicyId}/note`
            );
        }
    }

    return (
        <NotesList
            customerId={customerId}
            customerPolicyId={customerPolicyId}
            onAddEditClick={handleAddEditClick}
        />
    )
}